import { UseQueryOptions, useQuery } from "@tanstack/react-query"
import { APIS_KEYS } from "../../apis-keys"
import { IPropsGetGetTeamMemberRoles, IResponseGetGetTeamMemberRoles } from "./types"
import { GetTeamMemberRolesURL } from "../../../utils/constants"
import type { AxiosInstance, AxiosResponse } from "axios"
import { useApi } from "../../useApi"

async function getGetTeamMemberRoles(
	{ ...rest }: IPropsGetGetTeamMemberRoles,
	apiPrivate: AxiosInstance
) {
	try {
		const response: AxiosResponse<IResponseGetGetTeamMemberRoles> =
			await apiPrivate.get(`${GetTeamMemberRolesURL}`, {
				params: rest,
			})
		return response.data
	} catch (error: any) {
		console.log(error)
		throw new Error("something went wrong")
	}
}

export function useGetGetTeamMemberRoles(
	data: IPropsGetGetTeamMemberRoles,
	options?:
		| Omit<
				UseQueryOptions<
					IResponseGetGetTeamMemberRoles,
					unknown,
					IResponseGetGetTeamMemberRoles
				>,
				"queryKey" | "queryFn"
		  >
		| undefined
) {
	const { apiPrivate } = useApi()
	return useQuery({
		queryKey: [APIS_KEYS.GETTEAMMEMBERROLES, ...Object.values(data)],
		queryFn: () => getGetTeamMemberRoles(data, apiPrivate),
		...options,
	})
}
